/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment as env } from 'environments/environment';
import { LocalStorageService } from '../services/localstorage.service';
import { UtilityService } from '../services/utility_functions/utility_functions.service';


@Injectable()
export class AuthService {

    public onSuccessfullAuthentication = new BehaviorSubject<boolean>(false);
    private _httpClient: HttpClient;
    private _isCurrentUserZuperAgent = this._localStorageService.getLocalStorage('is_zuper_agent') === 'true';
    public isZuperAgentEnabled$ = new Subject<any>();

    constructor(private _handler: HttpBackend,
                private _localStorageService: LocalStorageService,
                private _utilityService: UtilityService) {
        this._httpClient = new HttpClient(_handler);

        this.isZuperAgentEnabled$.subscribe((res)=> {
            this._isCurrentUserZuperAgent = res;
        });
    }

    public isAuthenticated(): boolean {
        const token = this._localStorageService.getLocalStorage('auth_token');
        if (token && token.length > 10) {
            const tokenArray = token.split('.');
            if (tokenArray.length === 3) {
                const decodedPayload = JSON.parse(atob(tokenArray[1]));
                if (decodedPayload && decodedPayload['expires']) {
                    return Math.floor(Date.now() / 1000) < decodedPayload['expires'];
                }
                else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    public login(data): Observable<any> {
        const loginURL = `${this._localStorageService.getLocalStorage('dc_api_url')}/user/login`;
        return this._httpClient.post(loginURL, data);
    }

    public isModuleAccessable(module, state?): boolean{
        const user = this._localStorageService.getLocalStorage('user');
        const companyPolicy: any = this._localStorageService.getLocalStorage('company_policy');
        const companyConfig = this._localStorageService.getLocalStorage('company_configuration_data');
        const analyticsEnabled: boolean = companyPolicy?.advanced_analytics_enabled;
        const reportsEnabled: boolean = this._utilityService.hasPermission('settings.reports');
        const advancedReportsEnabled: boolean = companyPolicy?.reports?.is_enabled && (reportsEnabled || user?.role?.role_key === 'ADMIN');
        const isFinanceEnabledInPolicy: boolean = companyPolicy?.financing_enabled ;
        const isFinanceEnabledInConfig: boolean =  companyConfig?.financing?.is_enabled;
        const allowRecurringJob: boolean = companyConfig?.jobs?.allow_recurring_job;
        const isWorkflowEnabledInPolicy: boolean = companyPolicy?.workflows?.is_enabled;
        const projectTimelogEnabledInPolicy: boolean = companyConfig?.project?.timelog?.is_enabled;
        const jobtTimelogEnabledInPolicy: boolean = companyConfig?.jobs?.job_timelog?.is_enabled;
        const timesheetEnabledInConfig: boolean =  companyConfig?.timesheet?.is_enabled;
        const timelogModuleEnabled: boolean = companyPolicy?.enable_v2_timelog
        const loggedInUser = this._localStorageService.getLocalStorage('user');
        // localstorageservice is taking time to update the localstorage, so using localStorage directly to get the value
        const isZuperAgent: boolean = localStorage.getItem('is_zuper_agent') === "true";
        if(module?.moduleKey === ''){
            return true;
        }
        /* We do not check for permissions for payments since we do not have any permissions specific to payments*/
        if(module?.moduleKey === 'PAYMENTS'){
            return this._utilityService.hasModuleAccess(module?.moduleKey) && this._utilityService.hasModuleAccess('ESTIMATES', false, 'from_sidebar') && this._utilityService.hasModuleAccess('INVOICE', false, 'from_sidebar');
        }else if(module?.moduleKey === 'WORKFLOW' && isWorkflowEnabledInPolicy && !(env?.production && user?.role?.role_key !== 'ADMIN')){
            return true;
        }
        /*We do not have a module for FINANCE, but we do have a route /financing that needs to go through a validation.
        which is handled with the module key as FINANCE in local */
        else if (module?.moduleKey === 'FINANCE' && isFinanceEnabledInPolicy && isFinanceEnabledInConfig){
            if(this._utilityService.hasModuleAccess('INVOICE', false, 'from_sidebar') || this._utilityService.hasModuleAccess('ESTIMATES', false, 'from_sidebar')) {
                return true;
            }else{
                return false;
            }
        } else if (module?.moduleKey === 'SCHEDULE' && this._utilityService.hasModuleAccess(module?.moduleKey)) {
            if(module?.id === 'scheduler_menu') {
                if ((user?.role?.role_key === 'FIELD_EXECUTIVE' && !user?.access_role)) {
                    return false;
                } else if (this._utilityService.hasPermission('schedule.dispatch_board')) {
                    return true;
                }
                return false;
            }else if(module?.id === 'job_calendar' && !this._utilityService.hasPermission('schedule.calendar')){
                return false;
            }else{
                return true;
            }
        }
        else if(module?.moduleKey === 'TIMESHEET' && this._utilityService.hasModuleAccess(module?.moduleKey, false, 'from_sidebar')){
            if(module?.id === 'timeoff'){
                return this._utilityService.hasPermission('timesheet.manage_timeoff');
            } else  if(module?.id === 'timelog_summary_page'){
                return jobtTimelogEnabledInPolicy && this._utilityService.hasModuleAccess('JOB', false, 'from_sidebar')  && timelogModuleEnabled;
            }
            else{
                return true;
            }
        }
        else if(module?.moduleKey === 'PRODUCTS' && module?.id === 'stock-transfer-order'){
            return (companyPolicy?.transfer_order_enabled === true && this._utilityService.hasModuleAccess(module?.moduleKey, false, 'from_sidebar'));
        }else if(module?.moduleKey === 'PRODUCTS' && module?.id === 'price-list'){
            return (companyPolicy?.pricelist_enabled === true && this._utilityService.hasModuleAccess(module?.moduleKey, false, 'from_sidebar'));
        }
        else if( (module?.moduleKey === 'ADVANCED_ANALYTICS' && analyticsEnabled) || (module?.moduleKey === 'REPORTS' && reportsEnabled)){
            return true;
        }else if(module?.moduleKey === 'ADVANCED_REPORTS' && advancedReportsEnabled){
          // state is passed via canActive in auth guard
          if(state && state?.url){
            const fullUrl = state.url;
            const segments = fullUrl.split('/');
            const endpoint = segments[segments.length - 1];
            if(endpoint === 'templates' && user?.role?.role_key !== 'ADMIN'){
              return;
            }
          }
          return true;
        }else if (module?.moduleKey === 'JOB' && module?.id === 'recurring_jobs' && allowRecurringJob === false) {
            return false;
        }else if (module?.moduleKey === 'SERVICE_CONTRACTS' && module?.id === 'contracts') {
            return this._utilityService.hasModuleAccess('SERVICE_CONTRACTS', false, 'from_sidebar');
        }else if(module?.moduleKey === 'CONNECT' && this._utilityService.hasModuleAccess(module?.moduleKey)){
            return module?.id === 'zuper-connect' && this._isCurrentUserZuperAgent;
        }
        else if (this._utilityService.hasModuleAccess(module?.moduleKey, false, 'from_sidebar')) {
            return true;
        }
        return false; 
    }

    public isModuleAccessableForC2A(module: any): boolean {
        if(module?.moduleKey === 'CONNECT' && this._utilityService.hasModuleAccess(module?.moduleKey)){
            return module?.id === 'zuper-connect'
        }else{
            return this.isModuleAccessable(module)
        }
    }
}
